window.lp_raven_context = 'editor';
require('./base');
require('./jui');
require('./pom');
require('./lp-editor');
require('./modules');

// Required workaround for Material-Ui
// it adds the onTap functionality to react
// see https://github.com/zilverline/react-tap-event-plugin
var injectTapEventPlugin = require('react-tap-event-plugin');
injectTapEventPlugin();



// WEBPACK FOOTER //
// ./src/editor.js